import type { IPublicClientApplication } from '@azure/msal-browser';

let currentMsalInstance: IPublicClientApplication | null = null;

export const setMsalInstance = (instance: IPublicClientApplication): void => {
  currentMsalInstance = instance;
};

export const getMsalInstance = (): IPublicClientApplication => {
  if (!currentMsalInstance) {
    throw new Error('MSAL has not been initialized');
  }

  return currentMsalInstance;
};
